import { types, ISimpleType, IModelType } from 'mobx-state-tree'
import {
  default as colorNames,
  colorMap,
  ColorName,
  StaticColor
} from 'src/constants/colors'
import { darken, lighten, complement } from 'polished'
import { default as parseColor } from 'color-parse'
import { IColor } from './types'

const colorProps = {
  name: types.refinement(types.identifier, (value: any) =>
    colorNames.includes(value)
  ) as ISimpleType<ColorName>
}

const colorModel = types.model('Color', colorProps) as IModelType<
  typeof colorProps,
  { identifierAttribute: ColorName }
>

export const Color: IColor = colorModel.volatile((self) => {
  const color = colorMap[self.name]
  return {
    primary: color.default.hex,
    threeColor: {
      ...color.default,
      color: color.default.hex,
      opacity: color.default.alpha
    },
    ...Object.entries(color).reduce(
      (prev, [key, value]) => ({
        ...prev,
        [key]: value.hex
      }),
      {} as Record<keyof StaticColor, string>
    )
  }
})

// .views((self) => {
//   const color = colorMap[self.name]
//   // let dark: string = color?.dark.rgba,
//   //   darker: string = color?.darker.rgba,
//   //   light: string = color?.light.rgba,
//   //   lighter: string = color?.lighter.rgba,
//   //   complementColor: string = color?.complement.rgba
//   // if (typeof color === 'string') {
//   //   dark = darken(0.2, color)
//   //   darker = darken(0.5, color)
//   //   light = lighten(0.2, color)
//   //   lighter = lighten(0.5, color)
//   //   complementColor = complement(color)
//   //   const { alpha, values } = parseColor(color)
//   // } else {

//   // }
//   const views = Object.entries(color).reduce((p, [key, value]) => {
//     Object.defineProperty(p, key, {
//       get: () => {
//         return value.hex
//       }
//     })
//     return p
//   }, {})
//   Object.defineProperty(views, 'primary', {
//     get: () => {
//       return color.default
//     }
//   })
//   Object.defineProperty(views, 'threeColor', {
//     get: () => {
//       return {
//         ...color.default,
//         color: color.default.hex,
//         opacity: color.default.alpha
//       }
//     }
//   })

//   const test = {
//     get foo() {
//       return 'faaa'
//     }
//   }

//   console.log(test, views)

//   return views
//   // return {
//   //   get threeColor() {
//   //     return {
//   //       opacity: alpha,
//   //       color: `rgb(${values.join(',')})`
//   //     }
//   //   },
//   //   get primary() {
//   //     return color
//   //   },
//   //   get dark() {
//   //     return dark
//   //   },
//   //   get darker() {
//   //     return darker
//   //   },
//   //   get light() {
//   //     return light
//   //   },
//   //   get lighter() {
//   //     return lighter
//   //   },
//   //   get complement() {
//   //     return complementColor
//   //   }
//   // }
// })
